<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>{{text}}</v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn :color="yesColor" @click="close(true)">Yes</v-btn>
        <v-btn color="grey lighten-1" @click="close(false)">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    title: String,
    text: String,
    yesColor: String,
  },

  methods: {
    close(confirmed) {
      this.$emit('modalResult', confirmed);
    },
  },
};
</script>
